import { EnergyData, Resolution, TimePeriod } from "./types";
import { Project, ProjectWithGenerationSummary, Site, SiteWithGenerationSummary } from "../../types";

const getSiteWithGenerationSummary = async(siteId: string): Promise<SiteWithGenerationSummary> => {
    const response = await fetch(`/api/sites/${siteId}/summary/`);
    const data = await response.json();
    data.instance.latitude = Number(data.instance.latitude);
    data.instance.longitude = Number(data.instance.longitude);
    return data;
};

const getProjectWithGenerationSummary = async(projectId: string, siteIds?: number[]): Promise<ProjectWithGenerationSummary> => {
    const params = new URLSearchParams();
    if (siteIds && siteIds.length > 0) {
        params.append('site_ids', siteIds.join(','));
    }
    const queryString = params.toString() ? `?${params.toString()}` : '';
    const response = await fetch(`/api/projects/${projectId}/summary/${queryString}`);
    const data = await response.json();
    data.instance.sites.forEach((site: Site) => {
        site.latitude = Number(site.latitude);
        site.longitude = Number(site.longitude);
    });
    return data;
};

const getProject = async(projectId: string): Promise<Project> => {
    const response = await fetch(`/api/projects/${projectId}/`);
    const data = await response.json();
    data.sites.forEach((site: Site) => {
        site.latitude = Number(site.latitude);
        site.longitude = Number(site.longitude);
    });
    return data;
};  

const getSiteEnergy = async(siteId: string, period: TimePeriod, resolution: Resolution, date: Date): Promise<EnergyData> => {
    const response = await fetch(`/api/sites/${siteId}/data/${period}/${resolution}/${date.toISOString()}/`);
    if (!response.ok) {
        throw new Error(`Failed to fetch site energy data: ${response.statusText} ${response.status}`);
    }
    const data = await response.json();
    data.instance.latitude = Number(data.instance.latitude);
    data.instance.longitude = Number(data.instance.longitude);
    return data as EnergyData;
};

const getProjectEnergy = async(projectId: string, period: TimePeriod, resolution: Resolution, date: Date, siteIds?: number[]): Promise<EnergyData> => {
    const params = new URLSearchParams();
    if (siteIds && siteIds.length > 0) {
        params.append('site_ids', siteIds.join(','));
    }
    const queryString = params.toString() ? `?${params.toString()}` : '';
    const response = await fetch(`/api/projects/${projectId}/data/${period}/${resolution}/${date.toISOString()}/${queryString}`);
    if (!response.ok) {
        throw new Error(`Failed to fetch project energy data: ${response.statusText} ${response.status}`);
    }
    const data = await response.json();
    data.instance.sites.forEach((site: Site) => {
        site.latitude = Number(site.latitude);
        site.longitude = Number(site.longitude);
    });
    return data as EnergyData;
};

export { getSiteEnergy, getProjectEnergy, getSiteWithGenerationSummary, getProject, getProjectWithGenerationSummary };